import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Route, Router } from '@angular/router';
import { ColorVariant } from '@psei/ng/api';
import { DialogService, LegacyDialogConfig } from '@psei/ng/dialog';

import { Observable } from 'rxjs';
import { AccessToken } from 'src/app/shared/models/auth-token.model';
import { environment } from 'src/environments/environment';
import { SessionModel } from '../../shared/models/login-confirmation-response.model';
import { ApiVersionsModel } from '../../technical/version/api-versions.model';
import { ConfigurationService } from '../../technical/version/configuration.service';
import { UserElementalRole } from '../shared/models/user-elemental-role';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'ppb-app',
  templateUrl: './ppb-root.component.html',
  styleUrls: ['./ppb-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbRootComponent implements OnInit, AfterViewInit {
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<HTMLElement>;

  topbar = {
    user: {
      id: 'user',
      icon: { name: 'user' },
      name: ''
    },
  };

  appVersion = environment.appVersion;
  apiVersions$: Observable<ApiVersionsModel>;
  multipleSessions: SessionModel[];
  multipleSessionsHeader: string;
  authCredentials$: Observable<AccessToken>;
  projectTitle: string = $localize`:@@root.project_title:PORTAL PARTNERA BIZNESOWEGO`;

  constructor(
    private userService: UserService,
    private router: Router,
    private configurationService: ConfigurationService,
    private dialogBoxService: DialogService
  ) {
  }

  ngOnInit(): void {
    this.authCredentials$ = this.userService.authCredentials$;
    this.apiVersions$ = this.configurationService.apiVersion$;
  }

  ngAfterViewInit(): void {
    this.userService.multipleSessions$.subscribe((multipleSessions) => {
      this.multipleSessions = multipleSessions;
      if (this.multipleSessions?.length > 0) {
        this.multipleSessionsHeader = [
          $localize`:@@common.multiple_sessions_user_info:Dla użytkownika`,
          this.multipleSessions[0]?.username,
          $localize`:@@common.multiple_sessions_user_info_2:wykryto inne aktywne sesje:`
        ].join(' ')
        const dialog: LegacyDialogConfig<string> = this.generateDialog();

        this.dialogBoxService.legacy.open(dialog);
      }
    })
  }

  logOut(): void {
    // Try to navigate to handle guards, if possible invalidate token and navigate to login page
    this.router.navigateByUrl('/login').then((result) => {
      if (result) {
        this.dialogBoxService.legacy.closeCurrent();
        this.userService.logOut().subscribe(_ => this.router.navigateByUrl('/login'));
      }
    });
  }

  logItem($event: any): void {
    console.log('TOP TOOLBAR LOG ACTION', $event);
  }

  routeIsAllowed = (route: Route): boolean => {
    const role: UserElementalRole = route?.data?.requiredElementalRole;
    return role === undefined || this.userService.hasRole(role);
  }

  private generateDialog(): LegacyDialogConfig<string> {
    return {
      title: $localize`:@@common.multiple_sessions_header:Wykryto aktywne sesje`,
      content: this.dialogTemplate,
      buttons: [
        {
          label: $localize`:@@common.confirm:Potwierdź`,
          colorVariant: ColorVariant.Primary,
          onSelect: () => {
            this.multipleSessions = null;
            this.dialogBoxService.legacy.closeCurrent();
          },
        }
      ]
    };
  }
}
